import { render, staticRenderFns } from "./newNote.vue?vue&type=template&id=32c4d0f4&scoped=true&"
import script from "./newNote.vue?vue&type=script&lang=js&"
export * from "./newNote.vue?vue&type=script&lang=js&"
import style0 from "./newNote.vue?vue&type=style&index=0&id=32c4d0f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c4d0f4",
  null
  
)

export default component.exports